import { DrilldownTable, defaultTrafficLights, } from "../../../../../shared/interfaces-classes/index";
import { reportUtils } from "../../../../report-utils";
var getGenericGroupMsg = reportUtils.getGenericGroupMsg, getBoolFromBoolishVar = reportUtils.getBoolFromBoolishVar, processSingleVarHtml = reportUtils.processSingleVarHtml, tableDividerHtml = reportUtils.tableDividerHtml, cellDividerHtml = reportUtils.cellDividerHtml;
var genericGroupMsg = getGenericGroupMsg();
export var mod5 = {
    'http://ICTPMod5': {
        columns: [
            {
                parent: 'LO1a',
                variablename: 'LO1adash',
                desc: 'Demonstrate knowledge of the theory behind the IDA & necessity of using IDA',
                trafficLight: '',
                trafficLightGroupLogic: defaultTrafficLights,
                drilldown: {
                    vars: {
                        response: [
                            'driverimportantreason1chosen',
                            'driverimportantreason2chosen',
                            'driverimportantreason3chosen',
                            'IDAserviceagencypitch',
                            'preparationstepsincorrect',
                        ],
                    },
                    template: function (varDict) {
                        if (varDict.type === 'group') {
                            return genericGroupMsg;
                        }
                        var driverimportantreason1chosen = varDict.driverimportantreason1chosen, driverimportantreason2chosen = varDict.driverimportantreason2chosen, driverimportantreason3chosen = varDict.driverimportantreason3chosen, IDAserviceagencypitch = varDict.IDAserviceagencypitch, preparationstepsincorrect = varDict.preparationstepsincorrect;
                        // Part 1 ================================
                        var titlePart1 = "\n\t\t\t\t\t\t\t<h3><strong>Prompt:</strong> Select the main reason implementation drivers are important to the Grand County Triple P Coalition.</h3>\n\n\t\t\t\t\t\t\t<p><em>Select one option below.</em></p>\n\t\t\t\t\t\t";
                        var columnsPart1 = [
                            {
                                header: 'Reasons provided',
                                rows: [
                                    'Implementation Drivers provide a roadmap for navigating different stages or phases of the implementation process.',
                                    'By putting into place the structures and practices detailed in the implementation drivers, agencies promote practitioner’s delivery of Triple P as intended.',
                                    'Implementation Drivers directly relate to securing funding opportunities for Triple P scale-up and sustainability.',
                                ],
                            },
                            {
                                header: 'Correct reason',
                                type: 'checkmark',
                                allowEmpty: true,
                                rows: [
                                    '',
                                    true,
                                    '',
                                ]
                            },
                            {
                                header: 'Reason(s) chosen',
                                type: 'checkmark',
                                allowEmpty: true,
                                rows: [
                                    getBoolFromBoolishVar(driverimportantreason1chosen) || '',
                                    getBoolFromBoolishVar(driverimportantreason2chosen) || '',
                                    getBoolFromBoolishVar(driverimportantreason3chosen) || '',
                                ]
                            }
                        ];
                        var drilldownTableOptsPart1 = { varDict: varDict, columns: columnsPart1 };
                        var htmlPart1 = new DrilldownTable(drilldownTableOptsPart1).html;
                        // Part 2 ================================
                        var titlePart2 = "\n\t\t\t\t\t\t\t<h3><strong>Prompt:</strong> You are emailing your coalition to solicit agencies to participate in the IDA. What will you say?</h3>\n\t\t\t\t\t\t";
                        var columnsPart2 = [
                            {
                                header: 'Learner response',
                                rows: [
                                    IDAserviceagencypitch,
                                ],
                            },
                            {
                                header: 'ICTP ideal response',
                                rows: [
                                    "\n\t\t\t\t\t\t\t\t\t<p><strong>To better understand the strengths and supports your agency needs</strong> for the successful implementation of Triple P in your agency, we ask you to complete the <strong>Implementation Drivers Assessment for Agencies Implementing Triple P (IDA-TP)</strong>. Completing this assessment allows us to identify your organizational strengths in supporting the implementation of Triple P and structures and practices that may need to be improved over the next 6 months. </p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<p>The implementation structures and practices we assess using the IDA-TP have been found to strongly <strong>predict practitioner fidelity to Triple P session models</strong> and the <strong>sustainment of Triple P within your agency</strong>. Consider this assessment one key piece of the puzzle that helps us better understand how we can work together to <strong>support your organization to reach its goals and to consistently contribute to the shared child and family outcomes</strong> the Grand County Triple P Coalition aims to achieve.</p> \n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<p><strong>We\u2019ll use the results from the IDA-TP to make our collaborative Triple P action plans for the next 6 months</strong>, outlining priorities and next steps for your individual agency to effectively support the use of Triple P.</p> \n\t\t\t\t\t\t\t\t\t"
                                ]
                            }
                        ];
                        var drilldownTableOptsPart2 = { varDict: varDict, columns: columnsPart2 };
                        var htmlPart2 = new DrilldownTable(drilldownTableOptsPart2).html;
                        // Part 3 ================================
                        var titlePart3 = "\n\t\t\t\t\t\t\t<h3><strong>Prompt:</strong> Put the steps of preparing to complete the IDA-TP with Grand County Youth Organization in the appropriate order.</h3>\n\t\t\t\t\t\t";
                        var columnsPart3 = [
                            {
                                header: 'Appropriate order of steps:',
                                rows: [
                                    "\n\t\t\t\t\t\t\t\t\t\t<ol>\n\t\t\t\t\t\t\t\t\t\t\t<li>Provide a brief orientation to the purpose and objectives of the IDA-TP</li>\n\t\t\t\t\t\t\t\t\t\t\t<li>Discuss agency-level leadership and staff who would be most relevant to participate in the assessment</li>\n\t\t\t\t\t\t\t\t\t\t\t<li>Coordinate a date, time, and location for the assessment that works with all attendees\u2019 schedules</li>\n\t\t\t\t\t\t\t\t\t\t\t<li>Send a copy of the IDA-TP to agency participants and encourage them to review it but not discuss their scoring/ratings with each other</li>\n\t\t\t\t\t\t\t\t\t\t</ol>\n\t\t\t\t\t\t\t\t\t"
                                ],
                            },
                            {
                                header: 'Number of incorrect tries:',
                                rows: [
                                    preparationstepsincorrect,
                                ]
                            }
                        ];
                        var drilldownTableOptsPart3 = { varDict: varDict, columns: columnsPart3 };
                        var htmlPart3 = new DrilldownTable(drilldownTableOptsPart3).html;
                        return "\n\t\t\t\t\t\t\t" + titlePart1 + "\n\t\t\t\t\t\t\t" + htmlPart1 + "\n\n\t\t\t\t\t\t\t" + tableDividerHtml + "\n\n\t\t\t\t\t\t\t" + titlePart2 + "\n\t\t\t\t\t\t\t" + htmlPart2 + "\n\n\t\t\t\t\t\t\t" + tableDividerHtml + "\n\n\t\t\t\t\t\t\t" + titlePart3 + "\n\t\t\t\t\t\t\t" + htmlPart3 + "\n\t\t\t\t\t\t";
                    }
                },
            },
            {
                parent: 'LO1bi',
                variablename: 'LO1bi',
                desc: 'Demonstrate knowledge of the protocol',
                trafficLight: '',
                trafficLightGroupLogic: defaultTrafficLights,
                drilldown: {
                    vars: {
                        response: [
                            'facilitationcompetenciesA',
                            'facilitationcompetenciesB',
                            'facilitationcompetenciesC',
                            'facilitationcompetenciesD',
                            'teamchosenlatasha',
                            'teamchosenbrice',
                            'teamchosenalison',
                            'teamchosendeandre',
                        ],
                    },
                    template: function (varDict) {
                        if (varDict.type === 'group') {
                            return genericGroupMsg;
                        }
                        var facilitationcompetenciesA = varDict.facilitationcompetenciesA, facilitationcompetenciesB = varDict.facilitationcompetenciesB, facilitationcompetenciesC = varDict.facilitationcompetenciesC, facilitationcompetenciesD = varDict.facilitationcompetenciesD, teamchosenlatasha = varDict.teamchosenlatasha, teamchosenbrice = varDict.teamchosenbrice, teamchosenalison = varDict.teamchosenalison, teamchosendeandre = varDict.teamchosendeandre;
                        // Part 1 ================================
                        var titlePart1 = "\n\t\t\t\t\t\t\t<h3><strong>Prompt:</strong> Which of the following competencies might be helpful for accurate and reliable facilitation of the IDA-TP?</h3>\n\t\t\t\t\t\t";
                        var columnsPart1 = [
                            {
                                header: 'Competencies provided',
                                rows: [
                                    'Proficient with the IDA-TP instrument and specific indices',
                                    'Proficient with implementation science',
                                    'Proficient in delivering all levels of the Triple P system of interventions to families',
                                    'Strong in their facilitation and communication skills',
                                ],
                            },
                            {
                                header: 'Correct competencies',
                                type: 'checkmark',
                                allowEmpty: true,
                                rows: [
                                    true,
                                    true,
                                    '',
                                    true,
                                ]
                            },
                            {
                                header: 'Competencies chosen',
                                type: 'checkmark',
                                allowEmpty: true,
                                rows: [
                                    getBoolFromBoolishVar(facilitationcompetenciesA) || '',
                                    getBoolFromBoolishVar(facilitationcompetenciesB) || '',
                                    getBoolFromBoolishVar(facilitationcompetenciesC) || '',
                                    getBoolFromBoolishVar(facilitationcompetenciesD) || '',
                                ]
                            }
                        ];
                        var drilldownTableOptsPart1 = { varDict: varDict, columns: columnsPart1 };
                        var htmlPart1 = new DrilldownTable(drilldownTableOptsPart1).html;
                        // Part 2 ================================
                        var titlePart2 = "\n\t\t\t\t\t\t\t<h3><strong>Prompt:</strong> Select the team members that should participate as respondents for the IDA-TP at Grand County Youth Organization agency.</h3>\n\t\t\t\t\t\t";
                        var columnsPart2 = [
                            {
                                header: 'Potential team members',
                                rows: [
                                    "<strong>LaTasha</strong>: She is a data specialist who collates agency Triple P data to send to the Coalition Implementation Team and reports data out within Grand County Youth Organization and to external partners and stakeholders.",
                                    "<strong>Brice</strong>: He splits his time, both delivering Triple P seminars on occasion and participating as an agency implementation team member supporting the use of Triple P on a regular basis.",
                                    "<strong>Alison</strong>: She is an agency leader who oversees Triple P for Grand County Youth Organization, supervising several members of the agency implementation team and being responsible for most decisions related to Triple P.",
                                    "<strong>De\u2019 Andre</strong>: He is an enthusiastic Triple P provider trained in 3 levels of Triple P: Level 2 Seminar, Level 3 Primary Care, and Level 3 Discussion Group.",
                                ],
                            },
                            {
                                header: 'Correct team members',
                                type: 'checkmark',
                                allowEmpty: true,
                                rows: [
                                    true,
                                    true,
                                    true,
                                    '',
                                ]
                            },
                            {
                                header: 'Competencies chosen',
                                type: 'checkmark',
                                allowEmpty: true,
                                rows: [
                                    getBoolFromBoolishVar(teamchosenlatasha) || '',
                                    getBoolFromBoolishVar(teamchosenbrice) || '',
                                    getBoolFromBoolishVar(teamchosenalison) || '',
                                    getBoolFromBoolishVar(teamchosendeandre) || '',
                                ]
                            }
                        ];
                        var drilldownTableOptsPart2 = { varDict: varDict, columns: columnsPart2 };
                        var htmlPart2 = new DrilldownTable(drilldownTableOptsPart2).html;
                        return "\n\t\t\t\t\t\t\t" + titlePart1 + "\n\t\t\t\t\t\t\t" + htmlPart1 + "\n\n\t\t\t\t\t\t\t" + tableDividerHtml + "\n\n\t\t\t\t\t\t\t" + titlePart2 + "\n\t\t\t\t\t\t\t" + htmlPart2 + "\n\t\t\t\t\t\t";
                    }
                },
            },
            {
                parent: 'LO1biibasic',
                variablename: 'LO1biibasic',
                desc: 'Correctly utilize the voting numbers and modified consensus functions of the IDA-TP',
                trafficLight: '',
                trafficLightGroupLogic: defaultTrafficLights,
                drilldown: {
                    vars: {
                        response: [
                            'votingnumbersincorrect',
                            'consensus1',
                            'consensus2',
                        ],
                    },
                    template: function (varDict) {
                        if (varDict.type === 'group') {
                            return genericGroupMsg;
                        }
                        var votingnumbersincorrect = varDict.votingnumbersincorrect, consensus1 = varDict.consensus1, consensus2 = varDict.consensus2;
                        // Table 1 ================================
                        var columns1 = [
                            {
                                header: 'Correct assignment of scores:',
                                rows: [
                                    /*html*/ "\n\t\t\t\t\t\t\t\t\t\t<table>\n\t\t\t\t\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>No activities or elements are in place currently and/or have not been initiated.</td>\n\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>1</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>Some activities or items are in place and/or initiated currently.</td>\n\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>2</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>All activities or elements are in place currently and clear evidence is available to describe and support this.</td>\n\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t\t\t\t"
                                ],
                            },
                            {
                                header: 'How many tries to get to the correct score?',
                                rows: [
                                    votingnumbersincorrect,
                                ]
                            }
                        ];
                        var drilldownTableOpts1 = { varDict: varDict, columns: columns1 };
                        var html1 = new DrilldownTable(drilldownTableOpts1).html;
                        // Table 2 ================================
                        var columns2 = [
                            {
                                header: 'Scenario',
                                rows: [
                                    "\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t<div><strong>Narrator:</strong></div>\n\t\t\t\t\t\t\t\t\t\t<div>After preceding through several items with group agreements on the initial vote, you run into some differences on item 7.</div>\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t<div><strong>Facilitator:</strong></div>\n\t\t\t\t\t\t\t\t\t\t<div>Fidelity assessment procedures make use of multiple sources of information about practitioners\u2019 delivery of Triple P. Ready set vote!</div>\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t<div><strong>Result:</strong></div>\n\t\t\t\t\t\t\t\t\t\t<div>Latasha voted 2, Alison voted 0, and Brice voted 2</div>\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t<div><strong>Choice provided:</strong></div>\n\t\t\t\t\t\t\t\t\t\t<div>Move on to next item or modified consensus discussion</div>\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t",
                                    "\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t<div><strong>Narrator:</strong></div>\n\t\t\t\t\t\t\t\t\t\t<div>You have now completed the Fidelity Assessment and Decision-Support Data System indices, so it\u2019s time to move on to the Facilitative Administration (FAC) index and lastly the Systems Intervention Index. Knowing ahead of time the introduction and emphasis on the difference between these two indices can be tricky for participants to differentiate, you take care to follow the suggested transition script. You get to item two before a clarification is needed.</div>\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t<div><strong>Facilitator:</strong></div>\n\t\t\t\t\t\t\t\t\t\t<div>Internal agency policies and practices reflect evidence-informed active approaches to implementing Triple P. Ready set vote!</div>\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t<div><strong>Choice provided:</strong></div>\n\t\t\t\t\t\t\t\t\t\t<div>Move on to next item or modified consensus discussion</div>\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t"
                                ],
                            },
                            {
                                header: 'Correct choice',
                                rows: [
                                    'Move on to modified consensus discussion',
                                    'Move on to modified consensus discussion',
                                ]
                            },
                            {
                                header: 'Choice made',
                                rows: [
                                    consensus1,
                                    consensus2,
                                ]
                            },
                        ];
                        var drilldownTableOpts2 = { varDict: varDict, columns: columns2 };
                        var html2 = new DrilldownTable(drilldownTableOpts2).html;
                        return "\n\t\t\t\t\t\t\t<h3>Scoring</h3>\n\t\t\t\t\t\t\t" + html1 + "\n\n\t\t\t\t\t\t\t" + tableDividerHtml + "\n\n\t\t\t\t\t\t\t<h3>Modified consensus</h3>\n\t\t\t\t\t\t\t" + html2 + "\n\t\t\t\t\t\t";
                    }
                },
            },
            {
                parent: 'LO1biihandson',
                variablename: 'LO1biihandson',
                desc: 'Correctly administer the IDA-TP in a situated narrative scenario',
                trafficLight: '',
                trafficLightGroupLogic: defaultTrafficLights,
                drilldown: {
                    vars: {
                        response: [
                            'earlydiscussionresponse',
                            'adminconsensusvotingoption1',
                            'adminconsensusvotingoption2',
                            'adminconsensusvotingoption3',
                            'fidelityassessmentclarificationoption1',
                            'fidelityassessmentclarificationoption2',
                            'fidelityassessmentclarificationoption3',
                            'policiesproceduresoption1',
                            'policiesproceduresoption2',
                            'policiesproceduresoption3',
                            'votediscussionsummarybeforerevoteoption1',
                            'votediscussionsummarybeforerevoteoption2',
                            'votediscussionsummarybeforerevoteoption3',
                        ],
                    },
                    template: function (varDict) {
                        if (varDict.type === 'group') {
                            return genericGroupMsg;
                        }
                        var earlydiscussionresponse = varDict.earlydiscussionresponse;
                        // Table 1 ================================
                        var columns1 = [
                            {
                                header: 'Scenario',
                                rows: [
                                    "\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t<div><strong>Facilitator:</strong></div>\n\t\t\t\t\t\t\t\t\t\t<div>The agency has clearly identified who (regardless if individual or group) is responsible for ensuring the recruitment and selection of practitioners to deliver Triple P.</div>\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t<div><strong>Brice:</strong> <em>(jumps in before the vote)</em></div>\n\t\t\t\t\t\t\t\t\t\t<div>Currently, we\u2019re not training anyone in Triple P.</div>\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t<div><strong>Alison:</strong></div>\n\t\t\t\t\t\t\t\t\t\t<div>Yeah, we haven\u2019t trained anybody in the last 2 months.</div>\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t<div><strong>Narrator:</strong></div>\n\t\t\t\t\t\t\t\t\t\t<div>What would you say as the facilitator?</div>\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t"
                                ],
                            },
                            {
                                header: 'Suggested response',
                                rows: [
                                    "\n\t\t\t\t\t\t\t\t\t<p>Please think about what would happen if you were actively training people in Triple P. Is there a person or group of people who are responsible for ensuring recruitment and selection of practitioners? In other words, if you were going to select a new practitioner for Triple P tomorrow, who would ensure that happens?</p> \n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<p>Before you answer with a possible name or names, let\u2019s first take a vote to see whether there is agreement about such a person being in place as of today.</p>\n\t\t\t\t\t\t\t\t\t"
                                ],
                            },
                            {
                                header: 'Response constructed',
                                rows: [
                                    earlydiscussionresponse,
                                ],
                            }
                        ];
                        var drilldownTableOpts1 = { varDict: varDict, columns: columns1 };
                        var html1 = new DrilldownTable(drilldownTableOpts1).html;
                        // Table 2 ================================
                        var table2Column3TextOptions = {
                            adminconsensusvotingoption: [
                                'Ask participants to explain why they voted “1.”',
                                'Ask participants what action steps they might take to ensure this practice is “fully in place” before the next administration.',
                                "\n\t\t\t\t\t\t\t\t<p>Declare the consensus for scoring item #5 with a \u201C1\u201D.</p> \n\t\t\t\t\t\t\t\t<p>Then move directly to Coaching Index, item #6.</p>\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t",
                            ],
                            fidelityassessmentclarificationoption: [
                                'Great, what is the average adherence of your practitioners to Triple P session protocols based on your collected Triple P session checklists?',
                                'Great, how are you and your practitioners using those checklists within your agency?',
                                'Great, now you have one assessment of fidelity!',
                            ],
                            votediscussionsummarybeforerevoteoption: [
                                "\n\t\t\t\t\t\t\t\t<p>Great, it sounds like you may have agreement on a vote for now and a potential action item for the next few months. I love your clarification about how the dosage data is and is not currently utilized.</p> \n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<p>Ready to revote?</p>\n\t\t\t\t\t\t\t\t",
                                "\n\t\t\t\t\t\t\t\t<p>Great, it sounds like you\u2019ll have two fidelity measures in place.</p> \n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<p>Ready to revote?</p>\n\t\t\t\t\t\t\t\t",
                                "\n\t\t\t\t\t\t\t\t<p>Actually, you\u2019ll have 1 fidelity assessment in place based on this conversation.</p> \n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<p>Ready to revote?</p>\n\t\t\t\t\t\t\t\t",
                            ],
                            policiesproceduresoption: [
                                'You are right that is a barrier. Is there anyway Grand County Youth Organization can change its policies to fix that?',
                                'You are right that is a barrier. But remember, this section is about policies and procedures internal to Grand County Youth Organization; things you have direct control or influence over.',
                                'That sounds like a critical barrier. But that barrier will better apply in the next section, when we’ll focus on issues outside of your agency’s direct control.',
                            ],
                        };
                        function getTable2Column3Text(vblStem) {
                            var textList = Array.from({ length: 3 }, function (_, i) {
                                var _a, _b;
                                var key = "" + vblStem + (i + 1);
                                var userResponse = varDict[key];
                                if (userResponse === undefined) {
                                    return userResponse;
                                }
                                var getUserResponseBool = getBoolFromBoolishVar(userResponse);
                                return getUserResponseBool && "<div>" + ((_b = (_a = table2Column3TextOptions[vblStem]) === null || _a === void 0 ? void 0 : _a[i]) === null || _b === void 0 ? void 0 : _b.trim()) + "</div>";
                            });
                            if (textList.every(function (text) { return !text; })) {
                                return processSingleVarHtml();
                            }
                            return textList.filter(Boolean).join(cellDividerHtml);
                        }
                        var columns2 = [
                            {
                                header: 'Scenario',
                                rows: [
                                    "\n\t\t\t\t\t\t\t\t\t<p>After completing the Recruitment and Selection index, your team moves seamlessly through the Training index and the beginning of the Coaching index using the visuals, scoring notes, examples, and tips as a guide. Up next is item number 5 in the Coaching index.</p>\n\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t<div><strong>Facilitator:</strong></div>\n\t\t\t\t\t\t\t\t\t\t<div>Agency Triple P practitioners systematically participate in Triple P coaching following accreditation. [PAUSE] Ready set vote!</div>\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t<div><strong>Result:</strong></div>\n\t\t\t\t\t\t\t\t\t\t<div>All 3 vote 1</div>\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<p>What is the next right administration step?</p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t",
                                    "\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t<div><strong>Facilitator:</strong></div>\n\t\t\t\t\t\t\t\t\t\t<div>We should take a minute to celebrate how far we have come! Now, the next section focuses on your agency\u2019s efforts to assess whether or not core Triple P components are delivered as intended by Triple P practitioners to children and families. Just to be clear, we are talking about fidelity assessment rather than fidelity scores\u2026you can have high fidelity to Triple P but no assessment of fidelity.</div>\n\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t<p>In such a case, you just wouldn\u2019t know that your fidelity is high. For this section we are talking about the assessment process-not whether your practitioners are delivering with fidelity. I remember from past assessments that you did not have any fidelity assessments being carried out at that time.</p>\n\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t<p>Do you have any in place currently?</p>\n\t\t\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t<div><strong>Alison:</strong></div>\n\t\t\t\t\t\t\t\t\t\t<div>Now, we have our practitioners use the Triple P session checklist.</div>\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t<div><strong>Brice:</strong></div>\n\t\t\t\t\t\t\t\t\t\t<div>Yes, we made that change based on our last IDA-TP. All our practitioners now complete that checklist as they deliver Triple P to families.</div>\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t<div><strong>Narrator:</strong></div>\n\t\t\t\t\t\t\t\t\t\t<div>Great, what else would be important to ask here to clarify? </div>\n\t\t\t\t\t\t\t\t\t</p>\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t",
                                    "\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t<div><strong>Facilitator:</strong></div>\n\t\t\t\t\t\t\t\t\t\t<div>Okay, we have a 0 and a couple of 1\u2019s. Last time we started hearing from those that voted 0 so this time let\u2019s start with those that voted on the high end. Would anyone that voted a 1 like to share why they voted that way?</div>\n\t\t\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t<div><strong>LaTasha:</strong></div>\n\t\t\t\t\t\t\t\t\t\t<div>I voted \u201C1\u201D because I believe we have \u201Cin place\u201D several, but not all, active implementation approaches within Grand County Youth Organization, based on the examples you provided from the facilitator\u2019s guide. To me, our scores in the prior indices reflect that.</div>\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t<div><strong>Facilitator:</strong></div>\n\t\t\t\t\t\t\t\t\t\t<div>OK, let\u2019s hear from our participant that voted, \u201C0.\u201D</div>\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t<div><strong>Brice:</strong></div>\n\t\t\t\t\t\t\t\t\t\t<div>I voted \u201C0\u201D because we still do not have a workable billing code for Triple P like we do for our other family services. To me, this is the key barrier that is holding us back from stronger implementation.</div>\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t<div><strong>Narrator:</strong></div>\n\t\t\t\t\t\t\t\t\t\t<div>Pick the best clarification to provide.</div>\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t",
                                    "\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t<div><strong>Facilitator:</strong></div>\n\t\t\t\t\t\t\t\t\t\t<div>Okay, we have some 0\u2019s and some 2\u2019s. Does anybody want to share why they chose their vote?</div>\n\t\t\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t<div><strong>Alison:</strong></div>\n\t\t\t\t\t\t\t\t\t\t<div>I chose 0 because we only collect one source of fidelity assessment - the session checklist, which we discussed earlier.</div>\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t<div><strong>Brice:</strong></div>\n\t\t\t\t\t\t\t\t\t\t<div>Well, I chose 2 because it\u2019s occurred to me that we also record how many Triple P sessions practitioners complete with a family.</div>\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t<div><strong>Alison:</strong></div>\n\t\t\t\t\t\t\t\t\t\t<div>You\u2019re right. We do record that in case notes but I think its just for record keeping; I\u2019m not sure we really do anything with it, much less use it to assess dosage systematically across families in Grand County Youth Organization.</div>\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t<div><strong>LaTasha:</strong></div>\n\t\t\t\t\t\t\t\t\t\t<div>Yes, you\u2019re right, we don\u2019t necessarily use it for that. It\u2019s just for case records right now, unless we decide to do something different with that information.</div>\n\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t<div>Maybe we could incorporate it into our monthly Triple P data analysis and reporting process so we can take a look at it across the agency as a measure of Triple P fidelity? And perhaps consider how it might be helpful to feedback to practitioners through their ongoing coaching sessions?</div>\n\t\t\t\t\t\t\t\t\t</p> \n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t<div><strong>Narrator:</strong></div>\n\t\t\t\t\t\t\t\t\t\t<div>Select an option to respond to their discussion.</div>\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t",
                                ],
                            },
                            {
                                header: 'Correct choice',
                                rows: [
                                    "\n\t\t\t\t\t\t\t\t\t<p>Declare the consensus for scoring item #5 with a \u201C1\u201D.</p> \n\t\t\t\t\t\t\t\t\t<p>Then move directly to Coaching Index, item #6.</p>\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t",
                                    'Great, how are you and your practitioners using those checklists within your agency?',
                                    'You are right that is a barrier. But remember, this section is about policies and procedures internal to Grand County Youth Organization; things you have direct control or influence over.',
                                    "\n\t\t\t\t\t\t\t\t\t<p>Great, it sounds like you may have agreement on a vote for now and a potential action item for the next few months. I love your clarification about how the dosage data is and is not currently utilized.</p> \n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<p>Ready to revote?</p>\n\t\t\t\t\t\t\t\t\t",
                                ],
                            },
                            {
                                header: 'Choice made',
                                rows: [
                                    getTable2Column3Text('adminconsensusvotingoption'),
                                    getTable2Column3Text('fidelityassessmentclarificationoption'),
                                    getTable2Column3Text('policiesproceduresoption'),
                                    getTable2Column3Text('votediscussionsummarybeforerevoteoption'),
                                ],
                            }
                        ];
                        var drilldownTableOpts2 = { varDict: varDict, columns: columns2 };
                        var html2 = new DrilldownTable(drilldownTableOpts2).html;
                        return "\n\t\t\t\t\t\t\t<h3>Construct a response to discussion before voting</h3>\n\t\t\t\t\t\t\t" + html1 + "\n\n\t\t\t\t\t\t\t" + tableDividerHtml + "\n\n\t\t\t\t\t\t\t<h3>Administration</h3>\n\t\t\t\t\t\t\t" + html2 + "\n\t\t\t\t\t\t";
                    }
                },
            },
            {
                parent: 'LO1c',
                variablename: 'LO1c',
                desc: 'Properly score the IDA results',
                trafficLight: '',
                trafficLightGroupLogic: defaultTrafficLights,
                drilldown: {
                    vars: {
                        response: [
                            'TrainIndexScore',
                            'AIDIscore',
                            'ASPIscore',
                            'RSpercent',
                        ],
                    },
                    template: function (varDict) {
                        if (varDict.type === 'group') {
                            return genericGroupMsg;
                        }
                        var TrainIndexScore = varDict.TrainIndexScore, AIDIscore = varDict.AIDIscore, ASPIscore = varDict.ASPIscore, RSpercent = varDict.RSpercent;
                        var columns = [
                            {
                                header: 'Prompt',
                                rows: [
                                    'Now, try some IDA-TP scoring on your own. Here are the scores for the Training index items. What is the T index score?',
                                    'Now let’s take a look at all the index scores. Given this information, what would the Agency Implementation Drivers Summary index score be?',
                                    'Select to view the Agency Implementation Capacity and Systems Intervention item scores. Given this information, what is the Agency Sustainability Planning Index score?',
                                    "<p>Now let\u2019s convert the raw scores to percentage scores. For the Agency Implementation Capacity index, the raw score of 22 out of 32 translates to about 69 percent.</p> \n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<p>What is the percentage score for the Recruitment & Selection index?</p>",
                                ],
                            },
                            {
                                header: 'Correct score',
                                rows: [
                                    19,
                                    96,
                                    2,
                                    70,
                                ],
                            },
                            {
                                header: 'Score provided',
                                rows: [
                                    TrainIndexScore,
                                    AIDIscore,
                                    ASPIscore,
                                    RSpercent,
                                ],
                            }
                        ];
                        var drilldownTableOpts = { varDict: varDict, columns: columns };
                        var html = new DrilldownTable(drilldownTableOpts).html;
                        return html;
                    }
                },
            },
            {
                parent: 'LO1d',
                variablename: 'LO1d',
                desc: 'Utilize IDA results for action planning',
                trafficLight: '',
                trafficLightGroupLogic: defaultTrafficLights,
                drilldown: {
                    vars: {
                        response: [
                            'actionplanningindicescorrect',
                            'actionplanningindicesincorrect',
                            'actionplanningitemscorrect',
                            'actionplanningitemsincorrect',
                            'followupoption1',
                            'followupoption2',
                            'followupoption3',
                            'ASPIfollowup',
                        ],
                    },
                    template: function (varDict) {
                        if (varDict.type === 'group') {
                            return genericGroupMsg;
                        }
                        var actionplanningindicescorrect = varDict.actionplanningindicescorrect, actionplanningindicesincorrect = varDict.actionplanningindicesincorrect, actionplanningitemscorrect = varDict.actionplanningitemscorrect, actionplanningitemsincorrect = varDict.actionplanningitemsincorrect, ASPIfollowup = varDict.ASPIfollowup;
                        // Table 1 ================================
                        var columns1 = [
                            {
                                header: 'Type of items to select',
                                rows: [
                                    'Action planning indices',
                                    'Action planning items',
                                ],
                            },
                            {
                                header: 'Number of correct choices',
                                rows: [
                                    actionplanningindicescorrect,
                                    actionplanningitemscorrect,
                                ],
                            },
                            {
                                header: 'Number of incorrect choices',
                                rows: [
                                    actionplanningindicesincorrect,
                                    actionplanningitemsincorrect,
                                ],
                            }
                        ];
                        var drilldownTableOpts1 = { varDict: varDict, columns: columns1 };
                        var html1 = new DrilldownTable(drilldownTableOpts1).html;
                        // Table 2 ================================
                        var table2Column3TextOptions = {
                            followupoption: [
                                "\n\t\t\t\t\t\t\t\t<div><strong>OPTION 1</strong></div>\n\t\t\t\t\t\t\t\t<p>One area of needed growth for Grand County Youth Organization that was indicated by results from the IDA-TP was practitioner coaching.</p>\n\t\t\t\t\t\t\t\t \n\t\t\t\t\t\t\t\t<p>It is awesome you already have a person identified to do Triple P coaching that is well supported by leadership. A next step could be to fully develop and document that coaching plan you indicated you had partially in place.</p> \n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<p>Do you think that is something we could tackle together in the next few months?</p> \n\t\t\t\t\t\t\t\t",
                                "\n\t\t\t\t\t\t\t\t<div><strong>OPTION 2</strong></div>\n\t\t\t\t\t\t\t\t<p>Your agency had a clear area of weakness on the IDA-TP we recently completed together.</p>\n\n\t\t\t\t\t\t\t\t<p>You need to fully develop and document your practitioner coaching plan. When will you be able to do that?</p>\n\t\t\t\t\t\t\t\t",
                                "\n\t\t\t\t\t\t\t\t<div><strong>OPTION 3</strong></div>\n\t\t\t\t\t\t\t\t<p>One area of needed growth for Grand County Youth Organization that was indicated by results from the IDA-TP was practitioner coaching. </p>\n\n\t\t\t\t\t\t\t\t<p>You need to more fully develop and document your coaching plan to begin to address this area and ensure practitioners have the coaching supports they need to deliver Triple P as intended. </p>\n\t\t\t\t\t\t\t\t",
                            ],
                        };
                        function getTable2Column3Text(vblStem) {
                            var textList = Array.from({ length: 3 }, function (_, i) {
                                var _a, _b;
                                var key = "" + vblStem + (i + 1);
                                var userResponse = varDict[key];
                                if (userResponse === undefined) {
                                    // return processSingleVarHtml(userResponse);
                                    return userResponse;
                                }
                                var getUserResponseBool = getBoolFromBoolishVar(userResponse);
                                return getUserResponseBool && "<div>" + ((_b = (_a = table2Column3TextOptions[vblStem]) === null || _a === void 0 ? void 0 : _a[i]) === null || _b === void 0 ? void 0 : _b.trim()) + "</div>";
                            });
                            if (textList.every(function (text) { return !text; })) {
                                return processSingleVarHtml();
                            }
                            return textList.filter(Boolean).join(cellDividerHtml);
                        }
                        var columns2 = [
                            {
                                header: 'Scenario',
                                rows: [
                                    'How might you follow up with the agency regarding item 3?',
                                ],
                            },
                            {
                                header: 'Correct choice',
                                rows: [
                                    table2Column3TextOptions.followupoption[0],
                                ],
                            },
                            {
                                header: 'Choice made',
                                rows: [
                                    getTable2Column3Text('followupoption'),
                                ],
                            }
                        ];
                        var drilldownTableOpts2 = { varDict: varDict, columns: columns2 };
                        var html2 = new DrilldownTable(drilldownTableOpts2).html;
                        // Table 3 ================================
                        var columns3 = [
                            {
                                header: 'Prompt',
                                rows: [
                                    "\n\t\t\t\t\t\t\t\t\t<p>What is the best way to follow up on the 33% this agency received on the Agency Sustainability Planning index? Type your message here and select send.</p>\n\n\t\t\t\t\t\t\t\t\t<p>Hopefully your statement looked something like this and included some of the same key elements.</p>\n\t\t\t\t\t\t\t\t\t"
                                ],
                            },
                            {
                                header: 'Suggested message',
                                rows: [
                                    "\n\t\t\t\t\t\t\t\t\t<p>We want to ensure that we\u2019re <strong>setting up Triple P to be sustainable here within Grand County Youth Organization</strong>. One key practice that we\u2019ve learned to engage in early and often is sustainability planning. </p>\n\n\t\t\t\t\t\t\t\t\t<p><strong>Formal sustainability plans have shown to be a significant predictor of whether agencies continue delivering Triple P.  Based on the results from your most recent IDA-TP</strong>, it seems like this is one area <strong>we might work on together</strong> to make Triple P more sustainable in Grand County Youth Organization.</p> \n\n\t\t\t\t\t\t\t\t\t<p>Would you be interested in learning more about what agency sustainability planning incorporates? <strong>Perhaps we can put together an action plan</strong> to begin more fully developing and documenting your sustainability plans?</p>\n\t\t\t\t\t\t\t\t\t"
                                ],
                            },
                            {
                                header: 'Message constructed',
                                rows: [
                                    ASPIfollowup,
                                ],
                            },
                        ];
                        var drilldownTableOpts3 = { varDict: varDict, columns: columns3 };
                        var html3 = new DrilldownTable(drilldownTableOpts3).html;
                        return "\n\t\t\t\t\t\t\t<h3>Identifying follow-up focus</h3>\n\t\t\t\t\t\t\t" + html1 + "\n\n\t\t\t\t\t\t\t" + tableDividerHtml + "\n\n\t\t\t\t\t\t\t<h3>Following up</h3>\n\t\t\t\t\t\t\t" + html2 + "\n\n\t\t\t\t\t\t\t" + tableDividerHtml + "\n\n\t\t\t\t\t\t\t<h3></h3>\n\t\t\t\t\t\t\t" + html3 + "\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t";
                        // Title for 3?
                    }
                },
            },
        ],
        printouts: [
            {
                name: 'Customized Learner Summary',
                profileId: 'ictp-mod-5',
                project: 'ictp',
            }
        ],
    },
};
// export const mod5 = {
// 	'http://ICTPMod5': {
// 		type: 1,
// 		profileId: 'ictp-mod-5',
// 		hasPrintout: true,
// 		sections: [
// 			{
// 				title: 'Demonstrate knowledge of the theory behind the IDA & necessity of using IDA',
// 				note: 'Go over Appendix C regardless of module data',
// 				section: 'LO1A',
// 				activityList: [
// 					{
// 						activityName: 'LO1a overview: green/yellow/red light',
// 						color: '',
// 						variable: 'LO1Aoverview',
// 					},
// 					{
// 						title: 'Pitch constructed to deliver IDA to service agencies:',
// 						activityName: 'Pitch constructed to deliver IDA to service agencies',
// 						response: '',
// 						variable: 'IDAserviceagencypitch',
// 					},
// 				],
// 			},
// 			{
// 				title: 'Demonstrate knowledge of the protocol',
// 				section: 'LO1Bi',
// 				activityList: [
// 					{
// 						activityName: 'LO1bi overview: green/yellow/red light',
// 						color: '',
// 						variable: 'LO1bi',
// 					}
// 				],
// 			},
// 			{
// 				title: 'Demonstrate ability to utilize the protocol',
// 				section: 'LO1bii',
// 				note: '<strong>Regardless of module performance</strong>: review the introduction script (p.9-10) in the IDA Facilitator’s Guide, and ask site staff to explain the reasoning in their own words/everyday language',
// 				activityList: [
// 					{
// 						title: 'Understands protocol during administration',
// 						activityName: 'LO1bii basic: green/yellow/red light',
// 						color: '',
// 						variable: 'LO1biibasic',
// 					},
// 					{
// 						title: 'Constructed response to discussion before voting:',
// 						activityName: 'facilitator response to early discussion',
// 						response: '',
// 						variable: 'earlydiscussionresponse',
// 					}
// 				],
// 				// subSections: [],
// 				// activityList: [
// 				// 	{
// 				// 		title: 'UNDERSTANDS PROTOCOL DURING ADMINISTRATION',
// 				// 		note: 'Regardless of module performance review the introduction script (p.9-10) in the IDA Facilitator’s Guide, and ask site staff to explain the reasoning in their own words/everyday language',
// 				// 		activityList: [
// 				// 			{
// 				// 				activityName: 'LO1bii basic: green/yellow/red light',
// 				// 				color: '',
// 				// 				variable: 'LO1biibasic',
// 				// 			}
// 				// 		]
// 				// 	},
// 				// 	{
// 				// 		title: 'ADMINISTRATION CHOICES IN CONTEXT',
// 				// 		activityList: [
// 				// 			{
// 				// 				activityName: 'facilitator response to early discussion',
// 				// 				response: '',
// 				// 				variable: 'earlydiscussionresponse',
// 				// 			}
// 				// 		]
// 				// 	}
// 				// ],
// 			},
// 			{
// 				title: 'Properly score the IDA results',
// 				section: 'LO1c',
// 				activityList: [
// 					{
// 						activityName: 'LO1c: green/yellow/red light',
// 						color: '',
// 						variable: 'LO1c',
// 					}
// 				],
// 			},
// 			{
// 				title: 'Utilize IDA results for action planning',
// 				section: 'LO1d',
// 				activityList: [
// 					{
// 						activityName: 'LO1d: green/yellow/red light',
// 						color: '',
// 						variable: 'LO1d',
// 					},
// 					{
// 						title: 'Follow up on 33% ASPI Index:',
// 						activityName: 'Follow up on 33% ASPI Index',
// 						response: '',
// 						variable: 'ASPIfollowup',
// 					}
// 				],
// 			},
// 		],
// 	},
// };
